<script setup lang="ts">

interface Quote {
    quote: string,
    author: string,
    quote_color: string,
}

const props = defineProps<Quote>();

</script>
<template>
<section class="bg-white py-6 lg:py-12">
    <div class="container mx-auto max-w-3xl px-4 text-center">

      <blockquote class="text-2xl lg:text-3xl font-extrabold text-primary leading-tight" :style="{ color: quote_color }">
        {{ quote }}
      </blockquote>

      <p class="mt-4 text-lg text-black">
        {{ author }}
      </p>
    </div>
  </section>
</template>
